import { AuthorBio } from "../types/blog";

export const DEFAULT_AUTHOR_BIO: AuthorBio = {
  name: "Gabe Fletcher",
  imageUrl: "https://modest-heron-656.convex.cloud/api/storage/kg2fw2msfvtgmzpefd9755rskn7cdapw",
  headline: "Founder of AISeoBlogGenerator.com & EditMyPodcast.agency",
  tagline: "20 year marketer, web dev, SEO nut, sufferer of ADHD & addicted to driving real fast.",
  description: "I wanted a very specific copy tool, so I made one. The world will be shaped by those that do for themselves first and then help others. Developing is no different.",
  link1: {
    text: "Bolters.io - Bolt.new Trips & Tips",
    url: "https://bolters.io"
  },
  link2: {
    text: "Newsletter",
    url: "https://signup.makershelpdesk.com/"
  }
};